import { render, staticRenderFns } from "./ModalAddDocument.vue?vue&type=template&id=28d62405"
import script from "./ModalAddDocument.vue?vue&type=script&lang=js"
export * from "./ModalAddDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports